module.exports = __webpack_public_path__ + "img/Light_on.894b4d87.png";